/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Resource } from "~/generated/graphql";
import { TextButton } from "~/components/Styled";
import { GreyText } from "~/components/Tables/styles";
import { ROUTES } from "~/routing/routes";
import { isEmpty, isNotNil } from "~/tools";
import { ResourceGroupsModal } from "./ResourceGroupsModal";

type Props = {
  groups?: Resource["groupIdentifiers"];
};

export function ResourceGroupCell({ groups }: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const filteredGroups = useMemo(
    () => groups?.filter(isNotNil) ?? [],
    [groups]
  );

  if (isEmpty(filteredGroups)) {
    return <GreyText>Not in Resource Groups</GreyText>;
  }

  if (filteredGroups.length === 1) {
    const group = filteredGroups[0];
    return (
      <Link
        to={ROUTES.resourceGroups.generateDetails(group.id)}
        css={{ wordBreak: "break-word" }}
      >
        {group.name}
      </Link>
    );
  }

  return (
    <>
      <TextButton onClick={() => setIsModalOpen(true)} underline>
        In <b>{filteredGroups.length}</b> Resource Groups
      </TextButton>
      <ResourceGroupsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        groups={filteredGroups}
      />
    </>
  );
}
